import { render, staticRenderFns } from "./ApplyDiscount.vue?vue&type=template&id=7228ef0c&scoped=true"
import script from "./ApplyDiscount.vue?vue&type=script&lang=ts"
export * from "./ApplyDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228ef0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7228ef0c')) {
      api.createRecord('7228ef0c', component.options)
    } else {
      api.reload('7228ef0c', component.options)
    }
    module.hot.accept("./ApplyDiscount.vue?vue&type=template&id=7228ef0c&scoped=true", function () {
      api.rerender('7228ef0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ApplyDiscount.vue"
export default component.exports